import React from 'react';

// Job statuses as the shared client maps them, in plain words.
const STATUS_TEXT = Object.freeze({
  pending_upload: 'Upload not finished',
  queued: 'Waiting in queue',
  running: 'Scoring',
  completed: 'Ready',
  failed: 'Failed',
  cancelled: 'Cancelled',
});

const STATUS_ICON = Object.freeze({
  pending_upload: 'fa-hourglass-start',
  queued: 'fa-clock',
  running: 'fa-spinner fa-spin',
  completed: 'fa-check',
  failed: 'fa-times',
  cancelled: 'fa-ban',
});

export function statusText(status) {
  return STATUS_TEXT[status] || String(status || 'unknown').replace(/_/g, ' ');
}

export function StatusBadge({ status }) {
  return (
    <span className={`PROTEORISK-status-badge ${status}`}>
      <i className={`fas ${STATUS_ICON[status] || 'fa-circle'}`} aria-hidden="true" />
      {statusText(status)}
    </span>
  );
}

export function formatDate(ms) {
  if (!ms) return '';
  return new Date(Number(ms)).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatDateTime(ms) {
  if (!ms) return '';
  return new Date(Number(ms)).toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

// "Male, 58 years, BMI 29.4" from what was entered on the form.
export function jobSummary(metadata) {
  if (!metadata) return '';
  const parts = [];
  if (metadata.sex) parts.push(metadata.sex);
  if (metadata.age !== null && metadata.age !== undefined) parts.push(`${metadata.age} years`);
  if (metadata.bmi !== null && metadata.bmi !== undefined) parts.push(`BMI ${metadata.bmi}`);
  return parts.join(', ');
}
